export default [
    {
        title: "Interior Design Company",
        description:
            "This mockup features an elegant and modern design for an interior design website.",
        url: "https://www.behance.net/gallery/152522991/Interior-Design-Company-Website-Design",
        imgUrl: "https://i.imgur.com/hkdB1Ry.png",
    },
    {
        title: "King Muffins Mockup Site",
        description:
            "Bakery store website. The site showcases the store's products and locations.",
        url: "https://www.behance.net/gallery/152523837/Bakery-Website-Design-UI",
        imgUrl: "https://images.unsplash.com/photo-1570145820259-b5b80c5c8bd6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    },
    {
        title: "Hotel Chain Webpage Mockup",
        description:
            "This site showcases a simple and professional design for a hotel chain website.",
        url: "https://www.behance.net/gallery/152441121/Hotel-Website-UI-Design-HoteLink",
        imgUrl: "https://images.unsplash.com/photo-1586611292717-f828b167408c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    },
];
